import { all, takeEvery } from 'redux-saga/effects'
import { CALENDAR_REQUESTING } from './constants'
import getCalendarFlow from './flows/get-calendar-flow'

export function* watchCalendar() {
  yield all([takeEvery(CALENDAR_REQUESTING, getCalendarFlow)])
}
